import { Text } from "@fragments";
import { UserAvatar } from "@components/Community";

import { MEDAL_COLORS, MEDAL_COMPONENTS } from "@pages/Community/Group/enums/medals";

import "./styles.scss";

export default function PodiumCard({ member, position }) {
    const isPodium = position < 3;
    const MedalSvg = isPodium ? MEDAL_COMPONENTS[position] : null;
    const borderColor = isPodium ? MEDAL_COLORS[position] : "var(--surface-7)";

    return (
        <div className="podium-card">
            <div className="podium-card__avatar-ring" style={{ borderColor }}>
                <UserAvatar user={member} size={60} />
                {MedalSvg && (
                    <div className="podium-card__medal">
                        <MedalSvg width={28} height={28} />
                    </div>
                )}
            </div>

            <Text.span contrast={6} className="podium-card__name">
                {member.username}
            </Text.span>

            <Text.small contrast={5} weight={400} className="podium-card__points">
                {member.points} pts
            </Text.small>
        </div>
    );
}
